import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../common/Header';
import Footer from '../../common/Footer';
import './PathSelection.css';

export default function PathSelection() {
  const navigate = useNavigate();

  const handlePathSelection = (path) => {
    // Navigate to create page with path parameter
    navigate('/create', { state: { selectedPath: path } });
  };

  return (
    <div className="path-selection-container">
      <Header />
      
      <div className="path-selection-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <h1 className="text-center mb-5 path-title">
                اختر المسار التعليمي
              </h1>
              <p className="text-center mb-5 path-subtitle">
                اختر المسار التعليمي المناسب لطالبك
              </p>
            </div>
          </div>
          
          <div className="row justify-content-center">


            {/* Public Path Card - Left Side */}
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="path-card public-card" onClick={() => handlePathSelection('public')}>
                <div className="card-header">
                  <img 
                    src={require('../../assets/images/PublicLogoPath.png')} 
                    alt="Public Path Logo" 
                    className="path-logo"
                  />
                  <h3 className="path-name">المسار الأهلي (وطني)</h3>
                </div>
                <div className="card-body">
                  <p className="path-description">
                    المسار الأهلي في المملكة العربية السعودية هو مسار تعليمي محلي يدمج بين القيم التربوية الأصيلة والمحتوى الأكاديمي المتميز، بهدف إعداد جيل واعٍ ومؤهل يسهم في خدمة مجتمعه وبناء وطنه.
                  </p>
                  <p className="path-description">
                    المسار الأهلي في المملكة العربية السعودية هو مسار تعليمي محلي يوازن بين القيم التربوية الأصيلة والمناهج الأكاديمية الحديثة، ليُنشئ جيلاً واعياً ومتميزاً.
                  </p>
                  <p className="path-description">
                    يقدم المسار الأهلي تجربة تعليمية متكاملة تجمع بين الهوية الوطنية، التربية القيمية، والتميز الأكاديمي، بما يلبي تطلعات المجتمع السعودي.
                  </p>
                </div>
                <div className="card-footer">
                  <button className="select-path-btn public-btn">
                    اختر هذا المسار
                  </button>
                </div>
              </div>
            </div>


                        {/* American Path Card - Right Side */}
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="path-card american-card" onClick={() => handlePathSelection('american')}>
                <div className="card-header">
                  <img 
                    src={require('../../assets/images/AmericanLogoPath.png')} 
                    alt="American Path Logo" 
                    className="path-logo"
                  />
                  <h3 className="path-name">المسار الأمريكي والدبلوم الأمريكي (عالمي)</h3>
                </div>
                <div className="card-body">
                  <p className="path-description">
                    المسار العالمي في المملكة العربية السعودية هو مسار تعليمي بمعايير دولية معتمدة، يقدّم تعليماً متكاملاً يُمكّن الطلاب من اكتساب مهارات ومعارف حديثة تؤهلهم للالتحاق بأفضل الجامعات العالمية ومواكبة متطلبات العصر.
                  </p>
                  <p className="path-description">
                    المسار العالمي في المملكة العربية السعودية يُقدَّم وفق نظام تعليمي دولي معتمد، ويرتكز على بناء معارف ومهارات متقدمة تُعِد الطلاب للاندماج في بيئات جامعية عالمية ولمواكبة التطورات المعرفية والعلمية الحديثة.
                  </p>
                  <p className="path-description">
                    المسار العالمي تعليم بمعايير دولية معتمدة يفتح آفاق الطلاب نحو الجامعات العالمية ويؤهلهم لمهارات المستقبل.
                  </p>
                </div>
                <div className="card-footer">
                  <button className="select-path-btn american-btn">
                    اختر هذا المسار
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
